import { computed, inject, Injectable, signal } from '@angular/core';
import { ListItem } from '../../models/api/core/list/list-item';
import { Api } from '../api/api.service';

@Injectable({ providedIn: 'root' })
export class ClientListService {
  private api = inject(Api);

  clients = signal<ListItem[]>([]);
  isSingleClient = computed(() => this.clients().length === 1);
  singleClientValue = computed(() =>
    this.isSingleClient() ? this.clients()[0].value : null,
  );

  async load(): Promise<ListItem[]> {
    const response = await this.api.list.get();
    this.clients.set(response.clients);
    return this.clients();
  }
}
